import styled from 'styled-components';

export const StyledRegister = styled.div``;
